import React from "react";

const Announcementbar = () => {
  return (
    <svg width="148" height="43" viewBox="0 0 148 43" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_15409_1219)">
        <rect x="9" y="7" width="130" height="25" rx="4.5" stroke="#9EA7B6" />
        <rect x="16.5" y="15.5" width="26.9333" height="3" rx="1.5" fill="#DADEE6" />
        <rect x="16.5" y="20.5" width="45" height="3" rx="1.5" fill="#DADEE6" />
        <rect x="70" y="15" width="29" height="9" rx="4.5" fill="#FCFDFF" stroke="#9EA7B6" />
        <rect x="102" y="15" width="29" height="9" rx="4.5" fill="#DADEE6" stroke="#9EA7B6" />
      </g>
      <defs>
        <filter
          id="filter0_d_15409_1219"
          x="0.5"
          y="0.5"
          width="147"
          height="42"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.415686 0 0 0 0 0.45098 0 0 0 0 0.505882 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_15409_1219" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_15409_1219" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default Announcementbar;
